module.exports = __webpack_public_path__ + "assets/avatar-jbulb.5d339858.svg";